<template>
    <div class="shop__menu-bar">
        <button class='shop__menu-bar__filter'
            @click="toggleFilterDraw">Filter</button>
        <sort-dropdown />
        <transition name="slide-fade">
            <filter-drawer
                v-show="showFilterDraw"
                @toggle="toggleFilterDraw"
                @input="filterProducts"/>
        </transition>
    </div>
</template>

<script>
import SortDropdown from './SortDropdown';
import FilterDrawer from './FilterDrawer';

export default {
    name: 'MenuBar',
    data() {
        return {
            showFilterDraw: false,
        };
    },
    components: { SortDropdown, FilterDrawer },
    methods: {
        toggleFilterDraw() {
            this.showFilterDraw = !this.showFilterDraw;
        },
        filterProducts(filter) {
            this.$emit('input', filter);
        },
    },
};
</script>
